import React, { Component } from 'react';
import { CSVLink } from "react-csv";
import { authContext } from '../Login/AuthContext';

export default class AsyncCSV extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name:props.name,
      header:props.header,
      dataCSV:props.dataCSV,
      data: []
    }
    this.csvLinkEl = React.createRef();
  }
  state = {name:null,header:null, dataCSV:null, data:[]}
  static contextType = authContext;

  componentDidMount = () => {
    if(!this.context.auth.data.dataCSV)
      this.context.auth.data.dataCSV = [];
    this.context.auth.data.dataCSV[this.state.dataCSV] = [];
    this.context.auth.data.csvFileName = this.state.name;
    this.context.setAuthData(this.context.auth.data);
  }

  getData = () => {
    return this.context.auth.data.dataCSV[this.state.dataCSV];
  }
  getName = () => {
    return this.context.auth.data.csvFileName;
  }

  downloadReport = async () => {
    //console.log(this.state.dataCSV, this.state.header, global.dataCSV)
    const data = await this.getData();
    const name = await this.getName();
    this.setState({ data: data, name: name }, () => {
      setTimeout(() => {
        this.csvLinkEl.current.link.click();
      });
    });
  }

  render() {
    var data = this.state.data;
    var header = this.state.header;
    var name = this.state.name;
    return (
      <>
        <input type="button" value="Export to CSV" onClick={this.downloadReport} /> <CSVLink
          headers={header}
          filename={name+".csv"}
          data={data}
          ref={this.csvLinkEl}
        />
      </>
    );
  }
}
